import Flex from "../../../../designComponents/Flex";
import Typography from "../../../../designComponents/Typography";
import { IUtilityProviderType } from "./types";

type Props = {
  utilityProviders: (IUtilityProviderType & { categoryIcon: string })[];
};

export const UtilityProviderViewer = ({ utilityProviders }: Props) => {
  if (utilityProviders?.length === 0) {
    return null;
  }
  return (
    <div>
      {utilityProviders?.map((item) => {
        return (
          <Flex key={item._id} direction="column" gap={"4px"}>
            <Flex key={item._id} alignItems="center" gap={"6px"}>
              <img
                src={item.categoryIcon}
                alt="inventory category"
                style={{ height: "24px", width: "24px" }}
              />
              <Typography size="title" color="dark.black">
                {item?.category}
              </Typography>
            </Flex>
            <Flex alignItems="center">
              <Typography fontWeight="bold">Title:</Typography>
              <Typography size={"title"} color="dark.black">
                {item?.title}
              </Typography>
            </Flex>
            <Flex alignItems="center">
              <Typography fontWeight="bold">GPRN:</Typography>
              <Typography size={"title"} color="dark.black">
                {item?.gprn}
              </Typography>
            </Flex>
            <Flex alignItems="center">
              <Typography fontWeight="bold">MPRN:</Typography>
              <Typography size={"title"} color="dark.black">
                {item?.mprn}
              </Typography>
            </Flex>
          </Flex>
        );
      })}
    </div>
  );
};
